export enum M22LineType
{
    NULL_OPERATOR,
    NEW_PAGE,
    NARRATIVE,
    DRAW_BACKGROUND,
    PLAY_MUSIC,
    STOP_MUSIC,
    PLAY_STING,
    CHECKPOINT,
    COMMENT,
    SET_ACTIVE_TRANSITION,
    HIDE_WINDOW,
    SHOW_WINDOW,
    DIALOGUE,
    DRAW_CHARACTER,
    TRANSITION,
    CLEAR_CHARACTERS,
    CLEAR_CHARACTER,
    EXECUTE_FUNCTION,
    GOTO,
    WAIT,
    ENABLE_NOVEL_MODE,
    DISABLE_NOVEL_MODE,
    MAKE_DECISION,
    IF_STATEMENT,
    SET_FLAG,
    LOAD_SCRIPT,
    PLAY_VIDEO,
    MOVEMENT_SPEED,
    TEXT_SPEED,
    ANIMATION_TYPE,
    PLAY_SFX_LOOPED,
    STOP_SFX_LOOPED,
    NUM_OF_LINETYPES
}